import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../shared/modals/modal.component';

const BatchCalculationModal = ({ hideModal, isVisible }) => (
  <Modal
    className="calculate-message-modal"
    dismissText="Close"
    closeAction={hideModal}
    dismissAction={hideModal}
    isVisible={isVisible}
  >
    <div>
      Batch calculation in process.  Proforma calculation is blocked until the Batch calculation is complete.
    </div>
  </Modal>
);

BatchCalculationModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

export default BatchCalculationModal;
